{
  "mithrilDefense": "Mithril Defense©",
  "samlAuthentication": "SAML Authentication",
  "phoneNumber": "Phone Number",
  "logoutUrl": "Logout Url",
  "settings": "Settings",
  "appPermissionStatus": "App Permission Status",
  "noDataDisplayChart": "No data to display in this chart",
  "actualEvents": "Actual Events",
  "falseAlarms": "False Alarms",
  "month": "Month",
  "events": "Events",
  "eventsBreakdown": "Events Breakdown",
  "falseEvents": "False Events",
  "actualAlarms": "Actual Alarms",
  "statuses": "statuses",
  "grantedAllAccesses": "Granted all accesses",
  "noAccessToCamera": "No access to Camera",
  "noAccessToMicrophone": "No access to Microphone",
  "noAccessToNotifications": "No access to Notifications",
  "noAccessToLocation": "No access to Location",
  "enterApiUrl": "Enter Api URL",
  "reInviteSent": "Re-Invite sent",
  "reInvite": "Re-Invite",
  "copyInviteCode": "Copy invite code",
  "mainMenu": "Main menu",
  "inviteCodeCopied": "Invite Code Copied",
  "inviteCode": "Invite Code",
  "copyDistrictsInviteCodeShare": "Copy the district’s invite code to share access quickly.",
  "copy": "Copy",
  "submenuLabel": "{{text}} submenu",
  "home": "Home",
  "districts": "Districts",
  "incidents": "Incidents",
  "schools": "Schools",
  "domains": "Domains",
  "parents": "Parents",
  "totalDrones": "Total Drones",
  "admins": "Admins",
  "policies": "Policies",
  "directorySync": "Directory Sync",
  "alerts": "Alerts",
  "support": "Support",
  "feedback": "Feedback",
  "terms": "Terms",
  "thisDistrictIsDeactivatedPlease": "This district is deactivated. Please contact support.",
  "thisDistrictIsDeactivatedPlease2": "⚠️ This district is deactivated. Please contact your administrator for assistance.",
  "campusGuardianAngelSyncsWith": "Campus Guardian Angel syncs with external directories for end user (staff, students, etc) management via SAML. If you know your",
  "samlDetails": "SAML details",
  "youCanSetThisUp": ", you can set this up now, otherwise you can do it later. Once it’s setup, you can send an email to all the users via our admin panel to let them know that it’s ready.",
  "campusGuardianAngelSyncsWith2": "Campus Guardian Angel syncs with external directories for end user (staff, students, etc) management via SAML. If you know your SAML details, you can set this up now, otherwise you can do it later. Once it’s setup, you can send an email to all the users via our admin panel to let them know that it’s ready.",
  "pleaseVerifyTheRecaptcha": "Please verify the reCAPTCHA!",
  "welcomeToCampusGuardianAngel": "Welcome to Campus Guardian Angel",
  "toGetStartedYouLl": "To get started, you’ll need to validate your email address and cell phone number for authentication. Note that this is just for the admin panel - we use Single Sign On for all end users to access our mobile apps.",
  "getStarted": "Get Started",
  "alreadyGotAnAdminAccount": "Already got an admin account on Campus Guardian Angel?",
  "loginNow": "Login now!",
  "directorySyncSetUp": "Directory Sync set up successfully",
  "collapseSidebar": "Collapse sidebar",
  "expandSidebar": "Expand sidebar",
  "switchDistrict": "Switch district"
}
